module.exports = __webpack_public_path__ + "static/4-7a13954612a0bd19c381b95ed3d4a58b.jpg";